<ng-container *transloco="let t">
  <div class="align-items-center d-flex d-lg-none">
    <div class="pe-4 fw-bolder fs-5">
      <span>{{liveResult| rank:category:gender:measurementType}}</span>
    </div>
    <div class="d-flex flex-column py-3 flex-grow-1" [class.item-border-bottom]="hasBorderBottom">
      <div class="fw-bold line-height-12"> {{
          ((liveResult?.firstName ?? "")| titlecase) + " " + ((liveResult?.lastName
            ?? "") | titlecase)
        }}, <span class="fs-13-px fw-semibold">{{liveResult?.club ?? ""}} {{
            liveResult?.club || liveResult?.category ? "/" : ""
          }}
          {{liveResult?.category ?? ""}}
        </span>
      </div>
      <div class="d-flex flex-column fs-13-px fw-semibold">
        <div>
          {{t('competitor.table.start.number')}} {{': '}} {{liveResult?.startNumber ?? ""}}
        </div>
        <div class="d-flex flex-row align-items-center">
          <span>{{
              t("live.results.events.results.table.time") + ": "
              + (liveResult?.competitorResultsDetail | resultsTotalTime:measurementType:raceSettings?.measurementPrecisionType)
            }}</span>
          @if (!isRoundRace && liveResult?.competitorResultsDetail?.ltpCompetitorStageDetail) {
            <p class="fs-12">
              &nbsp;/&nbsp;{{liveResult?.competitorResultsDetail?.ltpCompetitorStageDetail | waypointNameByWaypointId}} </p>
          }
        </div>
        <span>{{
            t("live.results.events.results.table.gap") + ": " + (
              liveResult?.competitorResultsDetail | resultsGapTime:firstCompetitorResults?.competitorResultsDetail:measurementType:raceSettings?.measurementPrecisionType)
          }}</span>
        <span>{{
            t("live.results.events.results.table.laps") + ": "
            + (liveResult?.competitorResultsDetail | nmControlPointsOrLaps:isRoundRace)
          }}</span>
      </div>
    </div>
  </div>
</ng-container>
